import type { Member } from '@trello/model-types';

export const isPremOrganizationAdmin = (
  member: Pick<Member, 'idPremOrgsAdmin'>,
  idOrganization: string,
) => {
  return member.idPremOrgsAdmin.includes(idOrganization);
};
